import type { GasVolumeCompressibilityCalculator } from "../d";

export const beggsBrillCompressibilityCalculator: GasVolumeCompressibilityCalculator =
  params => {
    const { psuedoCriticals } = params;
    const { psuedoReducedTemperature, psuedoReducedPressure } = psuedoCriticals;

    // D73: =1.39*(D35-0.92)^0.5-0.36*D35-0.101
    const A =
      1.39 * Math.sqrt(psuedoReducedTemperature - 0.92) -
      0.36 * psuedoReducedTemperature -
      0.101;

    // D75: =(0.62-0.23*D35)*D36+((0.066/(D35-0.86))-0.037)*D36^2+(0.32/(10^9*(D35-1)))*D36^6
    const B =
      (0.62 - 0.23 * psuedoReducedTemperature) * psuedoReducedPressure +
      (0.066 / (psuedoReducedTemperature - 0.86) - 0.037) *
        psuedoReducedPressure ** 2 +
      (0.32 / (10 ** 9 * (psuedoReducedTemperature - 1))) *
        psuedoReducedPressure ** 6;

    // D77: =0.132-0.32*LOG10(D35)
    const C = 0.132 - 0.32 * Math.log10(psuedoReducedTemperature);

    // D79: =10^(0.3106-0.49*D35+0.1824*D35^2)
    const D =
      10 **
      (0.3106 -
        0.49 * psuedoReducedTemperature +
        0.1824 * psuedoReducedTemperature ** 2);

    // D81: =D73+((1-D73)/EXP(D75))+D77*D36^D79
    const gasCompressibilityFactor =
      A + (1 - A) / Math.exp(B) + C * psuedoReducedPressure ** D || 0;

    return {
      gasCompressibilityFactor,
      intermediates: {
        A,
        B,
        C,
        D,
        psuedoCriticals
      }
    };
  };
